
import finanzas_corporativas  from './finanzas_corporativas'
import tea  from './tea'
import comex  from './comex'
import mantenimiento from './configuracion'
import utilidades from './utilidades'
import capa_sele from './capa_sele'
import ryr from './ryr'
import control_calidad from './control_calidad'
import prog_agr from './prog_agr'
import cosecha from './cosecha'
import gestion_forecast from './gestion_forecast'
import bbss from './bbss'
import elli from './elli'
import mdisciplinarias from './mdisciplinarias'
import nomina from './nomina'
import hydra from './hydra_mant'

// Array of sections
export default [
  {
    header: ' ',
    resource: 'Inicio',
    action: 'read',
  },
  {
    title: 'Inicio',
    route: 'inicio',
    icon: 'HomeIcon',
    resource: 'Inicio',
    action: 'read',
  },

  ...capa_sele, ...comex,  ...control_calidad,...cosecha,...gestion_forecast,...bbss,...nomina, ...prog_agr, ...ryr, ...elli, ...tea, ...utilidades, ...hydra, ...mantenimiento,
  // ...mdisciplinarias
]
